"use client";

import { useEffect } from "react";

export default function NewRelicProvider() {
  useEffect(() => {
    (async () => {
      const { BrowserAgent } = await import("@newrelic/browser-agent/loaders/browser-agent");

      const options = {
        info: {
          applicationID: "1120217654",
          beacon: "bam.nr-data.net",
          errorBeacon: "bam.nr-data.net",
          licenseKey: "NRBR-6016ea1436e9a417fd8",
          sa: 1,
        },
        init: {
          ajax: { deny_list: ["bam.nr-data.net"] },
          browser_consent_mode: { enabled: false },
          distributed_tracing: { enabled: true },
          performance: {
            capture_detail: false,
            capture_marks: false,
            capture_measures: true,
          },
          privacy: { cookies_enabled: true },
        },
        loader_config: {
          accountID: "2364187",
          agentID: "1120217654",
          applicationID: "1120217654",
          licenseKey: "NRBR-6016ea1436e9a417fd8",
          trustKey: "2364187",
        },
      };

      new BrowserAgent(options);
    })();
  }, []);

  return null;
}
